import React from 'react';

interface CardProps {
    loading: boolean;
    children: React.ReactNode;
    className?: string;
}

const Card: React.FC<CardProps> = ({ loading, children, className = '' }) => {
    return (
        <div className={`${className} ${loading ? 'opacity-50' : ''}`}>{children}</div>
    );
};

export default Card;
